"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Grid = _interopRequireDefault(require("../Grid/Grid"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _IconButton = _interopRequireDefault(require("../IconButton/IconButton"));

var _CardContent = _interopRequireDefault(require("../Card/CardContent"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  transform: ", ";\n  transition: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledIconButton = (0, _styledComponents.default)(_IconButton.default)(_templateObject(), function (props) {
  return props['aria-expanded'] ? 'rotate(180deg)' : 'rotate(0deg)';
}, function (props) {
  return props.theme.transitions.create('transform', {
    duration: props.theme.transitions.duration.shortest
  });
});

var CollapseContent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CollapseContent, _React$Component);

  function CollapseContent() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CollapseContent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CollapseContent)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      expanded: false
    };

    _this.handleExpandClick = function () {
      _this.setState(function (state) {
        return {
          expanded: !state.expanded
        };
      });
    };

    return _this;
  }

  _createClass(CollapseContent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          visibleContent = _this$props.visibleContent,
          props = _objectWithoutProperties(_this$props, ["children", "visibleContent"]);

      return _react.default.createElement("div", props, _react.default.createElement(_Grid.default, {
        container: true,
        alignItems: "center",
        component: _CardContent.default
      }, _react.default.createElement(_Grid.default, {
        item: true,
        xs: true
      }, visibleContent), _react.default.createElement(StyledIconButton, {
        onClick: this.handleExpandClick,
        "aria-expanded": this.state.expanded,
        "aria-label": "Show more",
        size: "small"
      }, _react.default.createElement(_Icon.default, {
        name: "expand_more"
      }))), _react.default.createElement(_core.Collapse, {
        mountOnEnter: true,
        in: this.state.expanded
      }, _react.default.createElement(_CardContent.default, null, children)));
    }
  }]);

  return CollapseContent;
}(_react.default.Component);

var _default = CollapseContent;
exports.default = _default;